import { render, staticRenderFns } from "./MPager.vue?vue&type=template&id=41972608&"
import script from "./MPager.vue?vue&type=script&lang=ts&"
export * from "./MPager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports